import React, { Component } from 'react';
import { reduxForm, formValueSelector, Field } from 'redux-form';
import { connect } from 'react-redux';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import CustomAlert from './CustomAlert.js';
import SaveStepButton from './SaveStepButton.js';
import RenderField from './RenderField';

class ElectronicWalletForm extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { handleSubmit, submitting, error} = this.props;

        //const ElectronicWalletOption = [{id:0 , name:'Yacare'}, {id:1 , name:'Palta'}, {id:2 , name:'Ultra'}, {id:3 , name:'Ohana'}, {id:4 , name:'Linkinpost'}];
        const ElectronicWalletOption = [{id:0 , name:'Yacare'}, {id:1 , name:'Palta'}, {id:2 , name:'Ultra'}];

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_electronic_wallet" description="Electronic Wallet"/>
                        <div className="show-desktop">
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveElectronicWallet)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="electronic_wallet" defaultValue="Selecciona una opción" label="Selecciona una opción" attributeName='electronic_wallet' attributeOptions={ElectronicWalletOption}/>             
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

ElectronicWalletForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'electronic_wallet', required: true}])
ElectronicWalletForm = TopScrolleable(ElectronicWalletForm);

ElectronicWalletForm = reduxForm({
    form: 'ElectronicWalletForm', // a unique name for this form
    validate
})(ElectronicWalletForm);

ElectronicWalletForm = withAuthControl(ElectronicWalletForm);

export default ElectronicWalletForm;


/** WEBPACK FOOTER **
 ** ./src/components/ElectronicWalletForm.js
 **/